<div class="left">
  <p class="title">{{title}}</p>
  <p>{{body}}</p>
</div>

<div class="right">
  <i class="material-icons" (click)="dismiss()">close</i>
</div>
